class BlogSearchForm extends HTMLElement {
  constructor() {
    super();
    
    this.searchInput = this.querySelector('[ref="searchInput"]');
    this.resetButton = this.querySelector('[ref="resetButton"]');
    this.resultsWrapper = this.querySelector('[ref="resultsWrapper"]');
    this.resultsList = this.querySelector('[ref="resultsList"]');
    this.shop = this.dataset.shop;
    
    this.searchTimeout = null;
    this.isSearching = false;
    
    this.init();
  }

  init() {
    // Handle input changes with debounce
    this.searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      
      // Show/hide reset button
      if (query.length > 0) {
        this.resetButton.style.display = 'block';
      } else {
        this.resetButton.style.display = 'none';
        this.hideResults();
        return;
      }
      
      // Debounce search
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    });

    // Handle reset button click
    this.resetButton.addEventListener('click', () => {
      this.searchInput.value = '';
      this.resetButton.style.display = 'none';
      this.hideResults();
      this.searchInput.focus();
    });

    // Close results when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.hideResults();
      }
    });
    
    // Show results when input is focused and has value
    this.searchInput.addEventListener('focus', () => {
      if (this.searchInput.value.trim().length > 0 && this.resultsList.children.length > 0) {
        this.showResults();
      }
    });
  }

  async performSearch(query) {
    if (query.length === 0) {
      this.hideResults();
      return;
    }

    this.showLoading();
    this.isSearching = true;

    try {
      // Call Boost app API
      const url = `https://services.mybcapps.com/bc-sf-filter/search/suggest?shop=${this.shop}&q=${encodeURIComponent(query)}&suggestion_limit=0&product_limit=0&page_limit=10&dym_limit=0`;
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error('Search request failed');
      }

      const data = await response.json();
      
      this.displayResults(data.pages || [], query);
    } catch (error) {
      console.error('Blog search error:', error);
      this.showError();
    } finally {
      this.isSearching = false;
    }
  }

  displayResults(pages, query) {
    this.resultsList.innerHTML = '';

    if (pages.length === 0) {
      this.showNoResults(query);
      return;
    }

    pages.forEach(page => {
      const resultItem = document.createElement('div');
      resultItem.className = 'blog-search-form__result-item';
      
      const link = document.createElement('a');
      link.href = page.url;
      link.className = 'blog-search-form__result-link';
      
      const title = document.createElement('h3');
      title.className = 'blog-search-form__result-title';
      title.textContent = page.title;
      
      link.appendChild(title);
      
      // Add excerpt if available
      if (page.body_html) {
        const excerpt = document.createElement('p');
        excerpt.className = 'blog-search-form__result-excerpt';
        // Strip HTML and truncate
        const text = this.stripHtml(page.body_html);
        excerpt.textContent = this.truncateText(text, 120);
        link.appendChild(excerpt);
      }
      
      resultItem.appendChild(link);
      this.resultsList.appendChild(resultItem);
    });

    this.showResults();
  }

  showLoading() {
    this.resultsList.innerHTML = '<div class="blog-search-form__loading">Searching...</div>';
    this.showResults();
  }

  showNoResults(query) {
    this.resultsList.innerHTML = `<div class="blog-search-form__no-results">No blog posts found for "${this.escapeHtml(query)}"</div>`;
    this.showResults();
  }

  showError() {
    this.resultsList.innerHTML = '<div class="blog-search-form__no-results">An error occurred while searching. Please try again.</div>';
    this.showResults();
  }

  showResults() {
    this.resultsWrapper.style.display = 'block';
  }

  hideResults() {
    this.resultsWrapper.style.display = 'none';
  }

  stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength).trim() + '...';
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define('blog-search-form', BlogSearchForm);
